import AccountForm from './AccountForm.view';

export default AccountForm;
